import { createTheme } from '@mui/material/styles';
import type { PaletteColor, PaletteColorOptions } from '@mui/material/styles';
import { royalty, alienParasite, treasuredTeal, cowsMilk, neutral } from 'theme/palette';

// ── TypeScript augmentation ──────────────────────────────────────────────────
// Adds `teal` and `neutral` as valid palette keys so that `sx={{ color: 'teal.main' }}`
// and `theme.palette.neutral.ink` are fully typed.
declare module '@mui/material/styles' {
  interface Palette {
    teal: PaletteColor;
    neutral: {
      ink: string;
      surface: string;
    };
  }
  interface PaletteOptions {
    teal?: PaletteColorOptions;
    neutral?: {
      ink?: string;
      surface?: string;
    };
  }
}

export const theme = createTheme({
  palette: {
    primary: {
      main:         royalty.main,
      light:        royalty.light,
      dark:         royalty.dark,
      contrastText: '#ffffff',
    },
    secondary: {
      main:         alienParasite.main,
      light:        alienParasite.light,
      dark:         alienParasite.dark,
      contrastText: '#1a1a1a',
    },
    teal: {
      main:         treasuredTeal.main,
      light:        treasuredTeal.light,
      dark:         treasuredTeal.dark,
      contrastText: '#ffffff',
    },
    background: {
      default: cowsMilk.main,
      paper:   '#ffffff',
    },
    text: {
      primary:   '#1a1a1a',
      secondary: '#424242',
      disabled:  '#757575',
    },
    neutral: {
      ink:     neutral.ink,
      surface: neutral.surface,
    },
  },
});
